import { render, staticRenderFns } from "./DialogApproval.vue?vue&type=template&id=06f4ae40&scoped=true&"
import script from "./DialogApproval.vue?vue&type=script&lang=js&"
export * from "./DialogApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4ae40",
  null
  
)

export default component.exports